import { Link } from "react-router-dom";
import { MASCOT_FACE_URL } from "@/config/brand";
import { useTracking } from "@/hooks/useTracking";

const Navbar = () => {
  const { withTracking } = useTracking();
  return (
    <header
      data-testid="site-header"
      className="fixed top-0 inset-x-0 z-50 border-b border-white/10 bg-[#071735]/85 backdrop-blur-xl"
    >
      <div className="mx-auto flex h-16 md:h-20 max-w-5xl items-center justify-between px-5 md:px-10">
        <Link
          to={withTracking("/")}
          data-testid="nav-logo-link"
          className="flex items-center gap-3"
          aria-label="Same Day Home Services home"
        >
          <img
            src={MASCOT_FACE_URL}
            alt="Same Day Home Services"
            width={44}
            height={44}
            className="rounded-full border-2 border-sdh-sky/60"
          />
          <span className="leading-none">
            <span className="block text-[10px] font-bold uppercase tracking-[0.22em] text-sdh-sky">
              Same Day
            </span>
            <span className="block font-display text-lg uppercase tracking-[0.04em] text-white">
              Home Services
            </span>
          </span>
        </Link>
        <span className="hidden sm:block" />
      </div>
    </header>
  );
};

export default Navbar;
